import React from "react";
import { useProspectProfile } from "../../../contexts/ProsepctProfileContext";
import { FormColumn2Wide, Paper } from "best-common-react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import NameInput from "../fields/NameInput";

const Container = styled.div``;

const NameSection: React.FC = () => {
  const { t } = useTranslation("profile");
  const { profile, updateProfileField } = useProspectProfile();

  return (
    <Container>
      <Paper className="mb-3">{t("profile:nameSection")}</Paper>
      <div className="row pt-2">
        <FormColumn2Wide>
          <NameInput
            id="first-name"
            label={t("profile:firstName")}
            className="pb-2"
            required
            value={profile?.firstName}
            onChange={(value) => {
              updateProfileField("firstName", value);
            }}
          />
        </FormColumn2Wide>
        <FormColumn2Wide>
          <NameInput
            id="last-name"
            label={t("profile:lastName")}
            required
            value={profile?.lastName}
            onChange={(value) => {
              updateProfileField("lastName", value);
            }}
          />
        </FormColumn2Wide>
      </div>

      <div className="row pt-2">
        <FormColumn2Wide>
          <NameInput
            id="middle-name"
            label={t("profile:middleName")}
            className="pb-2"
            required
            value={profile?.middleName}
            onChange={(value) => {
              updateProfileField("middleName", value);
            }}
            showNA={true}
          />
        </FormColumn2Wide>
        <FormColumn2Wide>
          <NameInput
            id="ext-last-name"
            label={t("profile:extLastName")}
            required
            value={profile?.extLastName}
            onChange={(value) => {
              updateProfileField("extLastName", value);
            }}
            showNA={true}
          />
        </FormColumn2Wide>
      </div>
    </Container>
  );
};

export default NameSection;
